module.exports = __webpack_public_path__ + "static/media/468x60_0052_ro.042a8842.jpg";